import Top from '../components/Top/Index'
import Login from '../components/Login'
import StoreDetail from '../components/Static/StoreDetail'
import Environment from '../components/Static/Environment'
import Company from '../components/Static/Company'
import Privacy from '../components/Static/Privacy'
import Scta from '../components/Static/Scta'
import Terms from '../components/Static/Terms'
import CopyrightTerms from '../components/Static/CopyrightTerms'
import CopyrightAssignmentTerms from '../components/Static/CopyrightAssignmentTerms'
import Rules from '../components/Static/Rules'
import PasswordReset from '../components/PasswordReset'
import ComingSoon from '../components/Top/CommingSoon'
import TwitterCampaign from '../components/Static/TwitterCampaign'
import NarasuCreateTrackCampaign from '../components/Static/NarasuCreateTrackCampaign'
import NarasuFirstAnniversaryCampaign from '../components/Static/NarasuFirstAnniversaryCampaign'
import NarasuSpringCampaign2022 from '../components/Static/NarasuSpringCampaign2022'
import PayOffCompletelyCampaign202204 from '../components/Static/PayOffCompletelyCampaign202204'
import NarasuVocacolleCampaign202210 from '../components/Static/NarasuVocacolleCampaign202210'
import NarasuCampaign202308 from '../components/Static/NarasuCampaign202308'
// eslint-disable-next-line camelcase, import/extensions
import ZuMapSecondaryUsageFeeForBroadcastsTerms from '../components/Static/ZuMapSecondaryUsageFeeForBroadcastsTerms.vue'

export default [
  {
    path: '/client/',
    name: 'index',
    component: Top,
    meta: {
      sideMenuId: 'dashboard',
    },
  },
  {
    path: '/client/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/client/static/store-detail',
    name: 'store-detail',
    component: StoreDetail,
    meta: {
      sideMenuId: 'store',
    },
  },
  {
    path: '/client/static/environment',
    name: 'environment',
    component: Environment,
    meta: {
      sideMenuId: 'environment',
    },
  },
  {
    path: '/client/static/company',
    name: 'company',
    component: Company,
  },
  {
    path: '/client/static/privacy',
    name: 'privacy',
    component: Privacy,
  },
  {
    path: '/client/static/scta',
    name: 'scta',
    component: Scta,
  },
  {
    path: '/client/static/terms',
    name: 'terms',
    component: Terms,
    meta: {
      sideMenuId: 'terms',
    },
  },
  {
    path: '/client/static/copyright-terms',
    name: 'copyright-terms',
    component: CopyrightTerms,
    meta: {
      sideMenuId: 'copyright-terms',
    },
  },
  {
    path: '/client/static/copyright-assignment-terms',
    name: 'copyright-assignment-terms',
    component: CopyrightAssignmentTerms,
    meta: {
      sideMenuId: 'copyright-assignment-terms',
    },
  },
  {
    path: '/client/static/zu-map-secondary-usage-fee-for-broadcasts-terms',
    name: 'zu-map_secondary-usage-fee-for-broadcasts-terms',
    component: ZuMapSecondaryUsageFeeForBroadcastsTerms,
    meta: {
      sideMenuId: 'zu-map_secondary-usage-fee-for-broadcasts-terms',
    },
  },
  {
    path: '/client/static/rules',
    name: 'rules',
    component: Rules,
    meta: {
      sideMenuId: 'rules',
    },
  },
  {
    path: '/client/static/cam202110-01',
    name: 'twitter-campaign',
    component: TwitterCampaign,
  },
  {
    path: '/client/static/cam202110-02',
    name: 'narasu-create-track-campaign',
    component: NarasuCreateTrackCampaign,
  },
  {
    path: '/client/static/cam202112-01',
    name: 'narasu-first-anniversary-campaign',
    component: NarasuFirstAnniversaryCampaign,
  },
  {
    path: '/client/static/cam202204-01',
    name: 'narasu-spring-campaign-2022',
    component: NarasuSpringCampaign2022,
  },
  {
    path: '/client/static/cam202204-02',
    name: 'pay-off-completely-campaign-202204',
    component: PayOffCompletelyCampaign202204,
  },
  {
    path: '/client/static/cam202210-01',
    name: 'narasu-vocacolle-campaign-202210',
    component: NarasuVocacolleCampaign202210,
  },
  {
    path: '/client/static/cam202308',
    name: 'narasu-campaign-202308',
    component: NarasuCampaign202308,
  },
  {
    path: '/client/coming-soon',
    name: 'comingSoon',
    component: ComingSoon,
  },
  {
    path: '/client/password-reset',
    name: 'password-reset',
    component: PasswordReset,
  },
]
